import {VBtnToggle, VBtn} from 'vuetify/lib'
import TreeItem from './TreeItem.vue'
import Xfc from './XFc'
export default {
    data() {
        return {
            selected: 'zs'
        }
    },
    methods: {
        getListFromParent() {
            return this.$refs[this.selected].getListFromParent()
        }
    },
    render() {
        return <div>
            <VBtnToggle dense color="primary" v-model={this.selected} on={{
                change:() => this.getListFromParent()
            }}>
                <VBtn small value="zs">
                    岗位序列
                </VBtn>
                <VBtn small value="xf">
                    销服职能映射
                </VBtn>
            </VBtnToggle>
            <div style={{
                display: this.selected !== 'zs' ? 'none' : 'block'
            }}>
                <TreeItem ref="zs"/>
             
            </div>
            <div style={{
                display: this.selected !== 'xf' ? 'none' : 'block'
            }}>
                <Xfc ref="xf"/>
            </div>
        </div>
    }
}